<template>
  <div class="Login d-flex justify-content-center align-items-center min-vh-100">
    <div>
      <img
        class="hero"
        src="../assets/FinalLogo.png"
        style="flex: none; height: 250px; width: 250px;  margin-bottom: -60px;"
      />
      <h1 class="mb-3 px-1 py-1 mx-auto" style="color: #2596be">SOONFORWARD</h1>
      <b-alert :show="invalid" variant="warning" class="text-xs mb-4">
          Invalid account. Please try again with a valid account.
      </b-alert>
      <!-- <form @submit.prevent="authenticate"
        class="text-gray-100 mx-auto mb-5 px-5 py-3 rounded-lg shadow-lg"
        style="background: var(--bg-color); width: 400px;"
      >
        <b-alert :show="invalid" variant="warning" class="text-xs mb-4">
          There was an error with either the email or password. Please try again.
        </b-alert>
        <div class="floating-label-container position-relative mt-2">
          <b-icon-envelope
            class="text-gray-600 position-absolute"
            style="left: 0; top: 35%;"
          ></b-icon-envelope>
          <label class="col-form-label floating-label text-left" for="email">
            Email
          </label>
          <input
            id="email"
            class="form-control text-center pb-0"
            v-model="email"
            required
          />
        </div>
        <div class="floating-label-container position-relative">
          <b-icon-key
            class="text-gray-600 position-absolute"
            style="left: 0; top: 35%;"
          ></b-icon-key>
          <label class="col-form-label floating-label text-left" for="password">
            Password
          </label>
          <input
            id="password"
            class="form-control text-center pb-0"
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            required
          />
          <b-button
            type="button"
            class="text-gray-500 text-xs position-absolute border-0 py-0 px-1"
            variant="light"
            style="right: 0; top: 35%; background: var(--bg-color)"
            @click="showPassword = !showPassword"
          >
            <b-icon
              :icon="showPassword ? 'eye' : 'eye-slash'"
            ></b-icon>
          </b-button>
        </div>
        <b-button
          class="mt-4 mr-1 text-sm rounded-pill login-button"
          type="submit"
        >
          Login
        </b-button>
      </form> -->
      <!-- <button @click="googleSignIn">
          Sign In with Google
        </button> -->
      <!-- <div class="mx-auto mb-5 px-5 py-3" id="firebaseui-auth-container"></div> -->
      <b-button
        class="firebaseui-idp-button firebaseui-idp-google my-4"
        @click="googleSignIn"
        pill variant="light">
        <span class="firebaseui-idp-icon-wrapper">
          <img class="firebaseui-idp-icon" alt="" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"></span>
        <span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with Google</span>
        <span class="firebaseui-idp-text firebaseui-idp-text-short">Google</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
// import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import { login } from '../api/user';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      invalid: false,
    };
  },
  methods: {
    authenticate() {
      const data = { data: { email: this.email, password: this.password } };
      login(data).then((resp) => {
        console.log('Successfully POSTed');
        const { user } = resp.data;
        localStorage.setItem('user', JSON.stringify(user));
        this.$store.commit('authenticate', { jwt: resp.data });
        this.$router.push('/dash');
      }).catch((err) => {
        console.log(err);
        this.invalid = true;
      });
    },
    googleSignIn() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          const data = { data: { email: result.user.email } };
          login(data).then((resp) => {
            const { user } = resp.data;
            localStorage.setItem('user', JSON.stringify(user));
            this.$store.commit('authenticate', { jwt: resp.data });
            this.$router.push('/dash');
          }).catch((err) => {
            console.log(err);
            this.invalid = true;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.initFormlessFloatingLabels();
    // let ui = firebaseui.auth.AuthUI.getInstance();
    // if (!ui) {
    //   ui = new firebaseui.auth.AuthUI(firebase.auth());
    // }
    // const uiConfig = {
    //   signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
    //   signInFlow: 'popup',
    //   callbacks: {
    //     signInSuccessWithAuthResult: (authResult) => {
    //       const data = { data: { email: authResult.user.email } };
    //       login(data).then((resp) => {
    //         this.$store.commit('authenticate', { jwt: resp.data });
    //         this.$router.push('/dash');
    //       }).catch((err) => {
    //         console.log(err);
    //         this.invalid = true;
    //         ui.start('#firebaseui-auth-container', uiConfig);
    //       });
    //       return false;
    //     },
    //   },
    // };
    // ui.start('#firebaseui-auth-container', uiConfig);
  },
};
</script>

<!-- <style>
.firebaseui-idp-google {
  background-color: #5bd0fa !important;
}
</style> -->

<style scoped>
.form-control {
  background-color: transparent;
  border: none;
  border-bottom: 2px solid #cdcdcd;
  border-radius: 0;
}

.form-control:focus {
  background-color: transparent;
  box-shadow: none;
  border-color: var(--hover-color);
}

.floating-label-container{
  margin-top: 20px;
}

.floating-label {
  pointer-events: none;
  position: absolute;
  transform: translateX(-50%);
  z-index: 1;
  color: gray;
  transition: all 0.15s ease-out;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.floating-label.active {
  font-size: smaller;
  transform: translate(-50%, -63%);
}

.Login {
  background: radial-gradient(ellipse at top, var(--accent-color), var(--primary-color)),
  radial-gradient(ellipse at bottom, var(--hover-color), var(--secondary-color));
}

.login-button {
  background: var(--primary-color);
  border: none;
}

.login-button:hover {
  background: var(--secondary-color);
}

.signup-button {
  border: none;
  background: transparent;
  text-decoration: underline;
}
</style>
